import React from "react";

import { Flex, Box, P, Button } from "ui-components";
import { buttonThemes } from "ui-components/theme";
import { gotoUrl } from "utils/helpers";
import FormattedMessage from "components/FormattedMessage";
import { get, isNil } from "lodash";

const _imageStyle = {
  width: 450,
  mt: 10,
  px: 45
};

const _messageStyle = {
  mt: 20,
  mx: 20,
  textAlign: "center !important",
  fontWeight: "bold"
};

const backgroundColor = `${buttonThemes?.blue?.color} !important`;
const hoverColor = `${buttonThemes?.blue?.hoverColor} !important`;
const _buttonStyle = {
  background: backgroundColor,
  color: "#FFF",
  borderColor: backgroundColor,
  minWidth: "10rem !important",
  py: 12,
  borderRadius: 23,
  ":hover": {
    background: hoverColor,
    borderColor: hoverColor
  }
};

const Maintenance = ({ errorPagesConfig, appSettings }) => {
  const config = errorPagesConfig?.["maintenance"] || {};
  const showTimeInBanner = get(appSettings, "maintenanceAutomated.showTimeInBanner") || "12:00 am - 1.30am";
  const errorImage = config.image || "/assets/images/500-robot.png";
  const imageStyle = { ...(config.imageStyle || {}), ..._imageStyle };
  const imageAlt = config.imageAlt || "maintenance";
  const message = config.message || "maintenance_message";
  const messageStyle = { ...(config.messageStyle || {}), ..._messageStyle };
  const buttonText = get(appSettings, "maintenanceAutomated.buttonText") || config.buttonText;
  const buttonStyle = { ...(config.buttonStyle || {}), ..._buttonStyle };
  const redirectUrl = get(appSettings, "maintenanceAutomated.redirectUrl") || config.configUrl || "/circles1/sa_delivery";
  const showBtn = isNil(config.showBtn) ? true : config.showBtn;

  const values = {
    showTimeInBanner
  }

  const handleRedirectOnClick = () => {
    gotoUrl(redirectUrl, true, { relaunch: true }, false, false, true);
  };

  return (
    <Flex alignItems="center" flexDirection="column">
      <Box sx={imageStyle}>
        <img alt={imageAlt} src={errorImage} width="100%" height="auto" />
      </Box>
      <P sx={messageStyle}>
        <FormattedMessage html id={message} values={values} />
      </P>
      {showBtn && (
        <Box sx={{ mt: 20 }}>
          <Button sx={buttonStyle} onClick={handleRedirectOnClick}>
            {buttonText || <FormattedMessage id="retry" />}
          </Button>
        </Box>
      )}
    </Flex>
  );
};

export default Maintenance;
